import apiCall from "../utils/apiCall";

export default class CountryService {
    static listCountry = async () => {
        return await apiCall(`/api/countries/getorderedcountries`, "GET", null, null, null, true );
    }
}